<template>
  <div class="edit-container">
    <!-- 頭部 -->
    <div class="header">

      <h2 class="title">編輯資料</h2>
    </div>

    <div style="position: fixed; top: 30px; left: 30px;">
      <el-button icon="el-icon-arrow-left" @click="close" class="back-btn" plain size="small">
      </el-button>
    </div>

    <!-- 表單內容 -->
    <el-form ref="form" :model="form" label-width="80px" class="form-container" label-position="top">

      <!-- 頭像上傳 -->
      <el-form-item label="">
        <el-upload class="avatar-uploader" action="/api/file/upload" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="form.avatar" :src="'/api/file/download/' + form.avatar" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <!-- 用戶名修改 -->
      <el-form-item label="用戶名" prop="username">
        <el-input v-model="form.username" placeholder="請輸入用戶名" clearable maxlength="20" show-word-limit>
        </el-input>
      </el-form-item>

      <!-- 用戶名修改 -->
      <el-form-item label="Telegram" prop="telegram">
        <el-input v-model="form.telegram" placeholder="請輸入Telegram" clearable maxlength="20" show-word-limit>
        </el-input>
      </el-form-item>

      <!-- 提交按鈕 -->
      <!-- <el-button 
        type="primary" 
        class="submit-btn"
        @click="submitForm"
        round>
        保存修改
      </el-button> -->
      <div @click="submitForm"
        style="text-align: center; padding: 14px 0; text-align: center; background-color: #3E4F7A; color: white; border-radius: 100px; margin-top: 30px;">
        保存修改
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "editPage",
  data() {
    return {
      form: {
        avatar: '',
        username: '',
        telegram: ''
      },
      rules: {
        username: [
          { required: true, message: '用戶名不能為空', trigger: 'blur' }
        ],
        telegram: [
          { required: true, message: 'Telegram不能為空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$axios.get("/api/user/info").then(res => {
        let d = res.data.data
        this.form.username = d.nick
        this.form.avatar = d.img
        this.form.telegram = d.telegram
      })
    },
    close() {
      // 關閉邏輯
      this.$router.go(-1)
    },
    handleAvatarSuccess(res) {
      this.form.avatar = res.data

      // console.log(res.data)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上傳頭像圖片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上傳頭像圖片大小不能超過 2MB!');
      }
      return (isJPG || isPNG) && isLt2M;
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {

          this.$axios.post("/api/user/user_update", this.form).then((res) => {
            if (res.data.status == 0) {
              // 提交邏輯
              this.$message.success('修改成功！');
            }
          })
        }
      });
    }
  }
}
</script>

<style scoped>
.edit-container {
  padding: 16px;
  max-width: 600px;
  margin: 0 auto;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px 0;
  margin-bottom: 20px;
}

.back-btn {
  padding: 12px !important;
  border-radius: 8px;
}

.title {
  flex: 1;
  text-align: center;
  color: #3E4F7A;
  margin: 0;
  font-size: 18px;
}

.form-container {
  background: white;
  padding: 16px;
  border-radius: 8px;
}

.avatar-uploader {
  text-align: center;
}

.avatar-uploader>>>.el-upload {
  /* border: 1px dashed #d9d9d9; */
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.avatar-uploader>>>.el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.submit-btn {
  width: 100%;
  margin-top: 24px;
  padding: 12px;
}

/* 適配移動端表單 */
.el-form-item>>>.el-form-item__label {
  padding: 0 !important;
  margin-bottom: 8px;
}

.el-input>>>.el-input__inner {
  height: 48px;
  border-radius: 8px;
}
</style>
